<template>
<v-dialog v-model="showModal" persistent class="!bg-transparent !backdrop-blur-md !shadow-none " max-width="360">
    <v-card dark :class="`!bg-transparent !backdrop-blur-md !shadow-none !rounded-xl !border-[1px]  ${routeLink}-border`">
        <v-card-title :class="`${routeLink}_fortext !font-Handel   border-b-[1px] ${routeLink}-border`">
            {{ title }}
        </v-card-title>
        <div :class="`p-5  border-b-[1px] ${routeLink}-border font-Nunito `">
            {{ text }}
        </div>
        <div class="px-4 py-2 flex justify-end gap-2" >
            <v-btn :color="colorAsRoute" outlined @click.prevent="$emit('closeDialog')" >
                No
            </v-btn>
            <v-btn :color="colorAsRoute" outlined :loading="btnLoading" @click.prevent="$emit('confirmDialog')" >
                Yes
            </v-btn>
        </div>
    </v-card>
</v-dialog>
</template>
<script>
export default {
    props:{
        showModal: Boolean,
        title: String,
        text: String,
        btnLoading : Boolean,
    },
    computed: {
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        }
    },
}
</script>
<style scoped>

.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}
</style>